import i18n from 'i18n';

const accountServices = [
  {
    value: 'seo',
    label: 'SEO',
  },
  {
    value: 'content',
    label: i18n.t('Content'),
  },
  {
    value: 'media',
    label: i18n.t('Media'),
  },
  {
    value: 'wa',
    label: 'WA',
  },
  {
    value: 'locasty',
    label: 'Locasty',
  },
  {
    value: 'technology',
    label: i18n.t('Technology'),
  },
];

export { accountServices };
